module.exports = __webpack_public_path__ + "components/MapControl/svg/Szlak pieszy niebieski.svg?063fef56";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Szlak pieszy niebieski.svg
// module id = 2020
// module chunks = 0